export default {
  agm: "AGM Archive",
  businesses: "Business Listing",
  bylaws: "Bylaw",
  councillors: "Councillor",
  events: "Event",
  galleries: "Gallery",
  photos: "Gallery Photo",
  news: "News post",
  subscribers: "Newsletter Subscriber",
  pages: "Page",
  services: "Service"
};
